import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { Select } from '../../../../../../common/react/components/select';
import { getTranslation } from '../../../../../../common/react/utils/translations';
import { draftTrackerNavSelector } from '../../../../store/js/modules/draft-tracker/leaderboard/selectors';

export const ClubNavItem = ({ seasonId }) => {
    const dispatch = useDispatch();
    const nav = useSelector(draftTrackerNavSelector);
    const teamsList = useSelector(
        (state) => state.teams[`season_${seasonId}`] ?? []
    );
    const teams = [
        { providerId: -1, name: getTranslation('label.stats.allClubs') },
        ...teamsList.sort((a, b) => (a.name > b.name ? 1 : -1))
    ];

    useEffect(() => {
        dispatch(
            PULSE.app.redux.actions.teams.API__FETCH_TEAMS.request(seasonId)
        );
    }, []);

    return (
        <Select
            items={teams}
            itemToString={(team) => team?.name}
            initialSelectedItem={teams[0]}
            activeItem={teams.find((item) => item.providerId === nav.club)}
            label={getTranslation('label.filters.club')}
            onSelectedItemChange={({ selectedItem }) => {
                // RTK Query update: Update the Redux store with a slice action
                dispatch(
                    PULSE.app.redux.actions.draftTracker.updateNav({
                        name: 'club',
                        value: selectedItem.providerId
                    })
                );
            }}
        />
    );
};

ClubNavItem.propTypes = {
    seasonId: PropTypes.string.isRequired
};
